import { render, staticRenderFns } from "./order-card.vue?vue&type=template&id=418b8b41&scoped=true"
import script from "./order-card.vue?vue&type=script&lang=js"
export * from "./order-card.vue?vue&type=script&lang=js"
import style0 from "./order-card.vue?vue&type=style&index=0&id=418b8b41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418b8b41",
  null
  
)

export default component.exports